import { render, staticRenderFns } from "./dialogDbInfo.vue?vue&type=template&id=18dc6c3e&"
import script from "./dialogDbInfo.vue?vue&type=script&lang=js&"
export * from "./dialogDbInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogDbInfo.vue?vue&type=style&index=0&id=18dc6c3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports